// @ts-nocheck
// Thrown by the global fetch/axios interceptors in App.js when a backend call
// returns 401 (Redis session expired). Callers must early-return in catch blocks
// so the re-auth modal can recover without polluting UI with scary error messages.
export class SessionExpiredError extends Error {
  constructor() {
    super('Session expired');
    this.name = 'SessionExpiredError';
  }
}
